import { Controller, useFieldArray } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { getData } from "../../../utils/api";
import { Select2Data } from "../../../utils/common";

const PlanPriceSection = ({
  index,
  variant,
  fields,
  remove,
  total_price,
  register,
  getValues,
  errors,
  setValue,
  // planPriceValues,
  setHighestPrice,
  setHighestDuration,
  watchedWeeks,
  settotal_price,
  highestDuration,
  watch,
}) => {
  //   const planPriceValues = watch("plan_price");

  //   useEffect(() => {
  //     let maxDuration = 0;
  //     let maxPrice = 0;
  //     const mrp = parseFloat(total_price) || 0;

  //     planPriceValues.forEach((item, index) => {
  //       const duration = Number(item.duration) || 0;
  //       const calculatedPrice = duration * mrp;

  //       // Set individual price field
  //       setValue(`plan_price.${index}.price`, calculatedPrice.toFixed(2));

  //       // Track max duration and max price
  //       if (duration > maxDuration) {
  //         maxDuration = duration;
  //       }

  //       if (calculatedPrice > maxPrice) {
  //         maxPrice = calculatedPrice;
  //       }
  //     });
  //     console.log(maxDuration,'maxDuration');

  //     setHighestDuration(maxDuration * 4);
  //     setHighestPrice(maxPrice);
  //   }, [planPriceValues]);
  // console.log(planPriceValues,'planPriceValues  in plan plan');

  const durations =
    watch("plan_price")?.map((p) => Number(p.duration) || 0) || [];

  useEffect(() => {
    if (durations.length === 0) return;

    const maxDuration = Math.max(...durations);
    setHighestDuration(maxDuration*4);
  }, [durations, setHighestDuration]);

  useEffect(() => {
    const price = Number(
      (parseFloat(getValues(`plan_price.${index}.duration`)) *
        parseFloat(total_price)) /
        Number(highestDuration / 4)
    ).toFixed(2);

    setValue(`plan_price.${index}.price`, price);
  }, [getValues(`plan_price.${index}.duration`), total_price, highestDuration]);

  console.log(getValues(`plan_price.${index}.price`),'getValues(`plan_price.${index}.duration`) getValues(`plan_price.${index}.duration`)');
  
  return (
    <>
      <div key={variant.id} className="main-form-section mt-3">
        <Row>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Duration (in Month)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Duration"
                {...register(`plan_price.${index}.duration`, {
                  required: "Duration is required",
                })}
              />
              {errors?.plan_price?.[index]?.duration && (
                <p className="text-danger">
                  {errors.plan_price[index].duration.message}
                </p>
              )}
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="text"
                value={(
                  (parseFloat(getValues(`plan_price.${index}.duration`)) *
                    parseFloat(total_price)) /
                  Number(highestDuration / 4)
                ).toFixed(2)}
                readOnly
                placeholder="Variant Price"
                className="form-control"
              />

              {/* <Form.Control
                type="text"
                placeholder="Price"
                value={Number(
                  (parseFloat(getValues(`plan_price.${index}.duration`) || 0) *
                    parseFloat(total_price || 0)) /
                    (highestDuration / 4)
                ).toFixed(2)}
                {...register(`plan_price.${index}.price`, {
                  required: "Price is required",
                })}
                readOnly
              /> */}
              {errors?.plan_price?.[index]?.price && (
                <p className="text-danger">
                  {errors.plan_price[index].price.message}
                </p>
              )}
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label>MRP</Form.Label>
              <Form.Control
                type="text"
                placeholder="MRP"
                {...register(`plan_price.${index}.mrp`, {
                  required: "MRP is required",
                })}
              />
              {errors?.plan_price?.[index]?.mrp && (
                <p className="text-danger">
                  {errors.plan_price[index].mrp.message}
                </p>
              )}
            </Form.Group>
          </Col>
        </Row>

        {/* Remove button: disabled if only 1 item left */}
        {fields.length > 1 && (
          <button
            type="button"
            className="btn btn-danger mt-3"
            onClick={() => remove(index)}
          >
            Remove Plan Price
          </button>
        )}

        <hr />
      </div>
    </>
  );
};

export default PlanPriceSection;
